import { action } from 'satcheljs';
import CortanaComposeResult from '../store/schema/CortanaComposeResult';

const selectInlineSearchAction = action(
    'CORTANA_COMPOSE_SELECT_INLINE_SEARCH_ACTION',
    (result: CortanaComposeResult) => ({ result: result })
);

export default selectInlineSearchAction;
